import React, { useContext, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';
import axios from 'axios';
import { NAVIGATION_PATHS } from '../../static/navigationPaths.js';
import { LoaderContext } from '../../contexts/loaderContext.js';

const logout = async (sessionExpired, sessionIdleTimeout) => {
  try {
    // 1. Send the data to your Express app    
    sessionStorage.clear();
    await axios.post('api/logout', {
      sessionExpired,
      sessionIdleTimeout
    }, { withCredentials: true });

    // 2. NOW trigger the global logout
    // This navigates the browser window to the SSO
    // so the SSO session cookies can finally be cleared.
    // window.location.href = 'http://localhost:3000/oidc/session/end';

  } catch {
    //console.error('Local logout failed, but redirecting anyway...');
    // window.location.href = 'http://localhost:3000/oidc/session/end';
  }
};

const Logout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setLoading } = useContext(LoaderContext);

  useEffect(() => {
    const logoutUser = async () => {
      try {
        if (location.state?.sessionExpired) {
          setLoading(false);
          navigate(location.state.fromPath === '/' ? NAVIGATION_PATHS.LOGIN : NAVIGATION_PATHS.SESSION_TIMEOUT);
        } else if (location.state?.destroySession) {
          await logout(false, false);
          navigate(NAVIGATION_PATHS.SESSION_TIMEOUT, { state: { manualLogout: true, gatewayLogin: location.state.gatewayLogin } });
        }

      } catch {
        // something here? redirect somewhere?
      }
    };

    logoutUser();
  }, []);

  return <></>;
};

export default Logout;
